import axios from "axios";

// Smart Links — /api/smart-links.
//
// The reader side never receives the list of destination URLs: the page
// learns the card interval and whether any link is active, and on an eligible
// click the SERVER picks the link and enforces the cooldown.

export const BASE_URL =
  typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "http://localhost:5000"
    : "https://success-blog-app-backend.onrender.com";

function authConfig() {
  const token = localStorage.getItem("token");
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
}

const api = (path) => `${BASE_URL}/api/smart-links${path}`;

export const LINK_TYPES = [
  { value: "monetag", label: "Monetag" },
  { value: "product", label: "Product" },
  { value: "affiliate", label: "Affiliate" },
  { value: "other", label: "Other" },
];

// Mirrors the server's checkDestinationUrl so the admin sees the problem
// before saving. The server check is the one that counts.
export function checkDestinationUrl(raw) {
  const s = typeof raw === "string" ? raw.trim() : "";
  if (!s) return "Destination URL is required";
  if (s.length > 2048) return "Destination URL must be 2048 characters or fewer";
  if ([...s].some((ch) => /\s/.test(ch) || ch.charCodeAt(0) < 0x20 || ch.charCodeAt(0) === 0x7f)) {
    return "Destination URL must not contain spaces or control characters";
  }
  let u;
  try {
    u = new URL(s);
  } catch {
    return "Destination URL is not a valid URL";
  }
  if (u.protocol !== "http:" && u.protocol !== "https:") return "Destination URL must start with http:// or https://";
  if (u.username || u.password) return "Destination URL must not contain a username or password";
  if (!u.hostname.includes(".") || u.hostname.startsWith(".") || u.hostname.endsWith(".")) {
    return "Destination URL must point to a public website";
  }
  return "";
}

export const getSmartLinkConfig = () =>
  axios.get(api("/config"), authConfig()).then((r) => r.data);

// page: "readblogs" | "profile" | "authorprofile"
export const requestSmartRedirect = (position, page) =>
  axios.post(api("/redirect"), { position, page }, authConfig()).then((r) => r.data);

export const smartLinksAdmin = {
  listLinks: (status) =>
    axios.get(api("/admin/links"), { ...authConfig(), params: status ? { status } : {} }).then((r) => r.data.links),
  createLink: (body) => axios.post(api("/admin/links"), body, authConfig()).then((r) => r.data.link),
  updateLink: (id, body) => axios.put(api(`/admin/links/${id}`), body, authConfig()).then((r) => r.data.link),
  setStatus: (id, active) =>
    axios.patch(api(`/admin/links/${id}/status`), { active }, authConfig()).then((r) => r.data.link),
  deleteLink: (id) => axios.delete(api(`/admin/links/${id}`), authConfig()).then((r) => r.data),
  getSettings: () => axios.get(api("/admin/settings"), authConfig()).then((r) => r.data.settings),
  saveSettings: (body) => axios.put(api("/admin/settings"), body, authConfig()).then((r) => r.data.settings),
  getAnalytics: () => axios.get(api("/admin/analytics"), authConfig()).then((r) => r.data),
};
